import styled from 'styled-components';

export const EditFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1rem;
`;

export const EditForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  margin: 0 auto;
  max-width: 1000px;

  padding: 0 1rem;
`;

export const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 0.5rem;
  padding-block-end: 0.5rem;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 400;
  margin-inline-start: 1rem;

  & h2 {
    font-size: 1.125rem;
    margin: 0;
  }

  & span {
    font-size: 0.875rem;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;

  ${Styles.mobile} {
    gap: 0;
    flex-direction: column;
  }
`;

export const DeleteButtonContainer = styled.div`
  align-self: center;
  width: 50%;

  ${Styles.desktop} {
    width: calc(clamp(150px, 10%, 300px));
  }
`;

export const SaveButtonContainer = styled.div`
  align-self: center;

  border-block-start: 1px solid ${Styles.color.disabledBorder};
  margin-inline: -1rem;
  padding: 1rem;
  width: 100%;

  ${Styles.desktop} {
    padding: 1.5rem;
    display: flex;
    justify-content: center;
    margin-block-start: auto;

    > div {
      width: 35%;
    }
  }
`;
